import { render, staticRenderFns } from "./IndividualCourseStudentRankingPanel.vue?vue&type=template&id=ca98ba30&scoped=true"
import script from "./IndividualCourseStudentRankingPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseStudentRankingPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualCourseStudentRankingPanel.vue?vue&type=style&index=0&id=ca98ba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca98ba30",
  null
  
)

export default component.exports